module.exports = __webpack_public_path__ + "img/IMG_2204.0eb5cad6.jpg";